import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
    border-width: 4px;
    border-style: solid;
    border-color: rgb(64, 80, 198) rgb(243, 243, 243) rgb(243, 243, 243);
    border-image: initial;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    animation: ${spin} 2s linear infinite;
`;

export default Spinner;